var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5272 13.1631L19.907 18.543C20.0961 18.7322 20.2022 18.9888 20.2021 19.2563C20.2021 19.5238 20.0957 19.7804 19.9065 19.9695C19.7173 20.1586 19.4607 20.2647 19.1932 20.2646C18.9256 20.2646 18.6691 20.1582 18.48 19.969L13.1003 14.5891C11.4921 15.8347 9.46974 16.4209 7.44468 16.2284C5.41963 16.0359 3.54397 15.0791 2.19928 13.5527C0.854595 12.0263 0.141886 10.045 0.206145 8.01177C0.270403 5.97855 1.1068 4.04617 2.54519 2.60775C3.98358 1.16932 5.91591 0.332905 7.94908 0.268645C9.98225 0.204385 11.9635 0.917111 13.4899 2.26183C15.0162 3.60655 15.973 5.48226 16.1655 7.50736C16.358 9.53247 15.7718 11.5549 14.5262 13.1631H14.5272ZM8.20252 14.2641C9.79375 14.2641 11.3198 13.632 12.445 12.5068C13.5701 11.3816 14.2022 9.85548 14.2022 8.26422C14.2022 6.67296 13.5701 5.14686 12.445 4.02167C11.3198 2.89648 9.79375 2.26435 8.20252 2.26435C6.6113 2.26435 5.08524 2.89648 3.96008 4.02167C2.83491 5.14686 2.2028 6.67296 2.2028 8.26422C2.2028 9.85548 2.83491 11.3816 3.96008 12.5068C5.08524 13.632 6.6113 14.2641 8.20252 14.2641Z",
    fill: "#D2D2D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.63fd9465e9d936a7db135bc240020061.svg";
export { ForwardRef as ReactComponent };